/*
 *
 * GenericShopList
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 30-Jun-2025
*/

import GenericShopList from './GenericShopListContainer'

export default GenericShopList
